Namespace 'Customer.Filters'

class Customer.Filters.EditFilterTicketTabView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/edit_filter_ticket_tab']
  className: 'filter-ticket-container'

  initialize: ({statuses, allTypes, availableTypes, editable, filter, users, groups, userGroups}) ->
    @statuses = statuses
    @allTypes = allTypes
    @availableTypes = availableTypes
    @filter = filter
    @query = filter._queryWithDefaults().get('query')
    @users = users
    @groups = groups
    @userGroups = userGroups
    @editable = editable
    @subtypeFilterView = new Customer.Filters.Ticket.SubtypeFilterView(
      allTypes: @allTypes,
      availableTypes: @availableTypes,
      query: @query
    )
    @responseFilterView = new Customer.Filters.Ticket.ResponseFilterView(
      filter: @filter
    )
    @statusFilterView = new Customer.Filters.Ticket.StatusFilterView(
      statuses: @statuses,
      query: @query
    )
    @appointmentsFilterView = new Customer.Filters.Ticket.AppointmentsFilterView(
      filter: @filter
    )
    @assignedToFilterView = new Customer.Filters.Ticket.AssignedToFilterView(
      filter: @filter
      query: @query
      users: @users
      groups: @userGroups
    )
    @listenTo(@assignedToFilterView, 'assignedTo:change', -> Backbone.trigger 'customerSession:keepAlive')
    @groupsFilterView = new Customer.Filters.Ticket.GroupsFilterView(
      filter: @filter
      groups: @groups
    )

  render: ->
    @$el.html @template
      statuses: @statuses
      query: @query
    @renderSubtypeFilter()
    @renderResponseFilter()
    @renderStatusFilter()
    @renderAppointmentsFilter()
    @renderAssignedToFilter()
    @renderGroupsFilter()
    @

  renderSubtypeFilter: ->
    @$('.sub-type-filter-container').html(@subtypeFilterView.render().el)

  renderStatusFilter: ->
    @$('.status-filter-container').html(@statusFilterView.render().el)

  renderResponseFilter: ->
    @$('.response-filter-container').html(@responseFilterView.render().el)

  renderAppointmentsFilter: ->
    @$('.appointments-filter-container').html(@appointmentsFilterView.render().el)

  getAppointments: ->
    @appointmentsFilterView.getAppointments()

  getHasResponse: ->
    @responseFilterView.getHasResponse()

  renderAssignedToFilter: ->
    @$('.assigned-to-filter-container').html(@assignedToFilterView.render().el)

  updateAssignedTo: ->
    @assignedToFilterView.updateAssignedTo()

  renderGroupsFilter: ->
    @$('.groups-filter-container').html(@groupsFilterView.render().el)

  getIntelligentGroups: ->
    @groupsFilterView.getIntelligentGroups()

  showErrors: (errors) ->
    @subtypeFilterView.showError() if errors.includes('followers')

  cleanErrors: =>
    @subtypeFilterView.cleanError()
